export * from "./src/http-loader";



//////////////////
// WEBPACK FOOTER
// /www/sms-simulator/sms-front/~/@ngx-translate/http-loader/index.js
// module id = ../../../../@ngx-translate/http-loader/index.js
// module chunks = 3